import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";

import { ExternalLink } from "components/external-link";
import { ResponsiveBreakpoint, ResponsiveBreakpointType } from "constants/responsive-breakpoint";

export const contentPadding = css`
  padding: 36px 64px;

  @media (max-width: ${ResponsiveBreakpoint[ResponsiveBreakpointType.Mobile]}px) {
    padding: 20px;
  }
`;

export const contentPaddingSmallValue = 10;
export const contentPaddingSmall = css`
  padding: ${contentPaddingSmallValue}px;
`;

export const TooltipContents = styled.div`
  p {
    margin-bottom: 1em;

    &:last-child {
      margin-bottom: 0;
    }
  }

  a + a {
    margin-left: 5px;
  }
`;

const commonTooltipLink = css`
  text-decoration: underline;
  color: white;
`;

export const ExternalTooltipLink = styled(ExternalLink)`
  ${commonTooltipLink};
`;

export const TooltipLink = styled(Link)`
  ${commonTooltipLink};
`;

export const StyledHr = styled.hr`
  width: 100%;
  height: 1px;
  border: 0;
  margin: 0;
  background: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.borderColor
  };
`;

export const HiddenInput = styled.input`
  position: absolute;
  left: -9999em;
  visibility: hidden;
`;

const InputMessage = styled.div`
  margin-top: 3px;
  text-align: left;
  font-size: 13px;
`;

export const InputSuccessMessage = styled(InputMessage)`
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.successColor
  };
`;

export const InputErrorMessage = styled(InputMessage)`
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.warningColor
  };
`;
